import { render } from "./KbChatbotWidget.vue?vue&type=template&id=54cccf46"
import script from "./KbChatbotWidget.vue?vue&type=script&lang=js"
export * from "./KbChatbotWidget.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__